import { render, staticRenderFns } from "./OwImg.vue?vue&type=template&id=cbf12c3c&"
import script from "./OwImg.vue?vue&type=script&lang=js&"
export * from "./OwImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports